// extracted by mini-css-extract-plugin
export default {"header":"CreateTeamPopupForm_header__GXIlA","subtitle":"CreateTeamPopupForm_subtitle__mrI5q"};